import isZocdocBrand from '../../../utils/isZocdocBrand';
import { PROVIDER_STATUS } from '../constants';

export function isEligibleForUniversalSearchHeader(directoryId, providerIsPreview, providerStatus) {
    if (isZocdocBrand(directoryId)) {
        return providerIsPreview || providerStatus === PROVIDER_STATUS.Churned;
    }
    return false;
}
